import styles from './Radio.module.css';

export interface RadioOption {
    value: string | number;
    label: string;
    disabled?: boolean;
}

export interface RadioGroupProps {
    options: RadioOption[];
    value?: string | number;
    onChange?: (value: string | number) => void;
    name: string;
    label?: string;
    direction?: 'horizontal' | 'vertical';
    error?: boolean;
}

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
    value: string | number;
    checked?: boolean;
    onChange?: (value: string | number) => void;
    label?: string;
    name: string;
}

// Radio individual
export const Radio = ({
    value,
    checked = false,
    onChange,
    label,
    name,
    disabled = false,
    className = '',
    ...props
}: RadioProps) => {
    const handleChange = () => {
        if (onChange && !disabled) {
            onChange(value);
        }
    };

    return (
        <label className={`${styles.radioContainer} ${disabled ? styles.disabled : ''} ${className}`}>
            <div className={styles.radioWrapper}>
                <input
                    type="radio"
                    className={styles.radioInput}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                    {...props}
                />
                <div className={styles.radioCustom}>
                    <div className={styles.radioDot} />
                </div>
            </div>
            {label && <span className={styles.radioLabel}>{label}</span>}
        </label>
    );
};

// RadioGroup - Wrapper para múltiples radios
export const RadioGroup = ({
    options,
    value,
    onChange,
    name,
    label,
    direction = 'vertical',
    error = false,
}: RadioGroupProps) => {
    return (
        <div className={`${styles.radioGroup} ${error ? styles.error : ''}`}>
            {label && <label className={styles.groupLabel}>{label}</label>}
            <div className={`${styles.radioList} ${styles[`direction-${direction}`]}`}>
                {options.map((option) => (
                    <Radio
                        key={option.value}
                        name={name}
                        value={option.value}
                        label={option.label}
                        checked={value === option.value}
                        onChange={onChange}
                        disabled={option.disabled}
                    />
                ))}
            </div>
        </div>
    );
};
